/* Kilo — "Complete Your Caviar Experience" upsell add-ons.
   Adds selected complementary products to the cart via AJAX. If the custom
   cart drawer is present, it opens/refreshes the drawer after adding;
   otherwise it falls back to updating the header count (product page) or
   reloading (cart page). */
(function () {
  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    document.querySelectorAll('.kilo-header__cart-count').forEach(function (el) {
      el.textContent = '(' + cart.item_count + ')';
    });
  }

  function initUpsell(root) {
    if (!root || root.dataset.kiloUpsellReady === 'true') return;
    root.dataset.kiloUpsellReady = 'true';

    var context = root.getAttribute('data-kilo-upsell-context') || 'product';
    var addBtn = root.querySelector('[data-kilo-upsell-add]');
    var boxes = Array.prototype.slice.call(
      root.querySelectorAll('.kilo-upsell__checkbox')
    );
    if (!addBtn || !boxes.length) return;

    var defaultLabel = addBtn.textContent.trim() || 'Add selected to cart';

    function refreshButton() {
      var anyChecked = boxes.some(function (b) { return b.checked && !b.disabled; });
      addBtn.disabled = !anyChecked;
    }

    boxes.forEach(function (b) { b.addEventListener('change', refreshButton); });

    addBtn.addEventListener('click', function () {
      var items = boxes
        .filter(function (b) { return b.checked && !b.disabled; })
        .map(function (b) { return { id: parseInt(b.getAttribute('data-upsell-variant'), 10), quantity: 1 }; })
        .filter(function (item) { return item.id; });

      if (!items.length) return;

      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart);
          boxes.forEach(function (b) { b.checked = false; });

          // Prefer the drawer if it exists (any context).
          if (window.KiloCartDrawer) {
            addBtn.textContent = defaultLabel;
            refreshButton();
            window.KiloCartDrawer.refresh(cart);
            window.KiloCartDrawer.open();
            return;
          }

          if (context === 'cart') {
            window.location.reload();
            return;
          }

          addBtn.textContent = 'Added ✓';
          setTimeout(function () { addBtn.textContent = defaultLabel; refreshButton(); }, 1600);
        })
        .catch(function () {
          addBtn.textContent = 'Try again';
          addBtn.disabled = false;
        });
    });

    refreshButton();
  }

  function initAll() {
    document.querySelectorAll('[data-kilo-upsell]').forEach(initUpsell);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
